import Netx from '@netx/core/bootstrap';

export const getPreference = <Bool extends boolean = false>(
	key: string,
	asBoolean?: Bool,
) => {
	if (!Netx.user?.prefs)
		return (asBoolean ? false : undefined) as Bool extends true
			? boolean
			: undefined;
	return Netx.user?.prefs?.[asBoolean ? 'isTrue' : 'getPreference'](
		key,
	) as Bool extends true ? boolean : string | undefined;
};

export default getPreference;
